import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);

/** Register the PWA's service worker to handle the caching of the app's assets */
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx